import { BuiltinInstanceMemberValue } from '../BuiltinInstanceMemberValue';
export class SysCallInstanceMemberArray extends BuiltinInstanceMemberValue {
    constructor(syscall, valueType, type) {
        super();
        this.syscall = syscall;
        this.valueType = valueType;
        this.type = type;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.valueType }));
        sb.emitSysCall(node, this.syscall);
        sb.emitHelper(node, options, sb.helpers.wrapArrayVal({ type: this.type }));
    }
}

//# sourceMappingURL=SysCallInstanceMemberArray.js.map
